export async function affShipmentsGetCurrentSessionUseCase(trace_id, shipmentRepository) {

  const result = await shipmentRepository.aff_get_current_session(trace_id);

  const entity = new shipmentRepository.model_aff_prepare(result.data);

  if (!entity.isValid()) {
    console.log(entity)
    throw new Error("Shipments Aff get session Inválido");
  }

  return result;
}